// extracted by mini-css-extract-plugin
export default {"explanationText":"explanationText__RjXZm","valueTypeTab":"valueTypeTab__nnW7U","valueTypeLink":"valueTypeLink__MyQji"};